import { Identity, WidgetStyle } from '@sdbn/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { AppServerAPI } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ContextChange } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';

export class IgnoreTransport {
  identity: Identity;
  ignore: boolean;
}

@Component({
    selector: 'app-list-export-document',
    templateUrl: './list-export-document.component.html',
    styleUrls: ['./list-export-document.component.scss'],
    standalone: false
})
export class ListExportDocumentComponent extends AbstractWidgetComponent implements OnInit {

  constructor(
    public translationService: TranslationService,
    private appServerAPI: AppServerAPI
  ) {
    super();
  }

  form: FormGroup;

  documents = new Array<DocumentEntry>();
  templates = new Array<Template>();
  template: Template;

  dataSource: MatTableDataSource<DocumentEntry> = new MatTableDataSource(this.documents);

  columnsToDisplay = [
    'title',
    'documentDate'
  ];

  ngOnInit() {

    this.form = new FormGroup({
      dateFrom: new FormControl(new Date(), [Validators.required]),
      dateUntil: new FormControl(new Date(), [Validators.required]),
      template: new FormControl(null, [])
    });

    this.loadTemplates();

  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  loadTemplates() {
    this.appServerAPI.execute<Template[]>(`/client/control/reporting/listexcel-get-templates`, {}).subscribe(response => {
      this.templates.splice(0, this.templates.length);
      for (const p of response) {
        this.templates.push(new Template(p));
      }
      if (this.templates.length > 0) {
        this.form.controls.template.setValue(this.templates[0].id + '');
      }
    });
  }

  updateList() {
    const selection = new DocumentSelection(this.form.value.dateFrom, this.form.value.dateUntil, parseInt(this.form.value.template), 200);
    this.dataSource.data = [];

    this.appServerAPI.execute<any>(`/client/control/reporting/listexport-document`, selection)
      .subscribe(
        response => {
          this.documents.splice(0, this.documents.length);
          for (const p of response) {
            this.documents.push(new DocumentEntry(p));
          }
          this.dataSource.data = this.documents;
        }
      );
  }

  createExcel() {

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'listexcel-document');

    // keep focus in current window
    window.focus();

    const selection = new DocumentSelection(this.form.value.dateFrom, this.form.value.dateUntil, parseInt(this.form.value.template), null);
    const url = `/client/control/reporting/listexcel-document`;
    this.appServerAPI.postWithArraybufferResponse<any>(url, selection).subscribe(result => {

      const file = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  public isUpdateListDisabled(): boolean {
    return this.form.value.dateFrom == null || this.form.value.dateUntil == null;
  }

  public isCreateDisabled(): boolean {
    return this.form.value.dateFrom == null || this.form.value.dateUntil == null || this.form.value.template == null;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}

class Template {
  constructor(entry: any) {
    this.id = entry.id;
    this.dictionaryKey = entry.nameDictionaryKey;
  }
  id: number;
  dictionaryKey: string;
}

class DocumentSelection {
  constructor(from: Date, until: Date, template: number, limit: number) {
    this.from = from;
    this.until = until;
    this.template = template;
    this.limit = limit;
  }
  from: Date;
  until: Date;
  limit: number;
  template: number;
}

export class DocumentValue {
  constructor(entry: any) {
    this.key = entry.key;
    this.value = entry.value;
  }
  key: string;
  value: string;
}

export class DocumentEntry {
  constructor(entry: any) {
    this.id = entry.id;
    this.title = entry.title;
    this.documentDate = entry.documentDate;
    this.template = entry.template;
    for (const value of entry.values) {
      this.values.push(new DocumentValue(value));
    }
  }
  id: number;
  title: string;
  documentDate: Date;
  template: string;
  values = new Array<DocumentValue>();
}
